import { Inject, Injectable, PLATFORM_ID,EventEmitter } from "@angular/core";
import { CONFIG } from './config.service';
import { isPlatformBrowser } from '@angular/common';
import { AppConfigService } from "@citi-gcg-173875/citi-utils";
import { CRSFidoCustomTransport } from '../fido/crsfido-transport';
import { CRSFidoAuthCustomTransport } from '../fido/crsfido-authenticate-transport';




declare let xmsdk: any;
declare let xmui: any;
declare let CustomUIHandler: any;
declare let com: any;

@Injectable()
export class CrsFidoService {
    private window: any;
    constructor(
        @Inject(CONFIG) private config,
        public _appConfigService: AppConfigService,
        @Inject(PLATFORM_ID) private platformId: string) {
    }

    initialize(responseData: any, flowType: 'legacy' | 'nga' = 'legacy'): Promise<boolean> {
        return new Promise<boolean>((resolve) => {
            if (isPlatformBrowser(this.platformId)) {
                const { protocol, hostname, port } = document.location;

                const config = this._appConfigService.getConfig("api");
                const api = config;

                const transmitEndpoint = (api.host) ? `${api.host}${api.path}ts-web` : `${protocol}//${hostname}/${api.path}ts-web`;

                const appId = api.tmtAppId;
                const apiTokenId = "";
                const apiToken = "";
                let siteId = localStorage.getItem("siteId");
                let fusionUserId = localStorage.getItem(siteId +"_fidoUserId");
                let userId = localStorage.getItem(siteId +"_userId");
                var params: any;
                params={
                    "fusionUser": userId,
                    "jwtToken": responseData.biometricJWTToken,
                    "siteId": siteId
                }
                const transmitContainer = document.getElementById("transmitContainer") ;
                var clientContext: any;
                clientContext={
                    uiContainer: transmitContainer
                };

                var sdk = xmsdk.XmSdk();

                var connectionSettings =
                    com.ts.mobile.sdk.SDKConnectionSettings.create(
                        transmitEndpoint, appId, apiTokenId, apiToken);
                sdk.setConnectionSettings(connectionSettings);
                sdk.setLogLevel(com.ts.mobile.sdk.LogLevel.Debug);
                sdk.setUiHandler(new CustomUIHandler());
                var myProvider = new CRSFidoCustomTransport(api.headers.client_id);
                sdk.setUiAssetsDownloadMode(
                    com.ts.mobile.sdk.UIAssetsDownloadMode.Disable);
                sdk.setTransportProvider(myProvider);

                sdk.initialize().then( (initializeRes) => {
                    sdk.authenticate(fusionUserId, "preCheckFIDO2Eligibility", params, clientContext).then( (result) => {
                        let json_data = result._internalData.json_data;
                        this.setLocalStorage(json_data);
                        sdk.logout();
                        this.redirectToNgaSignon();
                        resolve(true);
                    }).catch( (error) => {
                        sdk.logout();
                        if (flowType === 'legacy') {
                            this.redirectToNgaSignon();
                        }
                        resolve(false);
                    });
                }).catch( (err) => {
                    sdk.logout();
                    if (flowType === 'legacy') {
                        this.redirectToNgaSignon();
                    }
                    resolve(false);
                });

            } else {
                console.log('in fidocrs service server side');
                resolve(false);
            }
        });
    }

    authenticationJourney(){
        return new Promise((resolve,reject)=>{
        let biometricToken = null;
        try{
            const { protocol, hostname, port } = document.location;

            const config = this._appConfigService.getConfig("api");
            const api = config;
            //console.log(`fidocrs service api details is ${JSON.stringify(api)}`);
            const transmitEndpoint = (api.host) ? `${api.host}${api.path}ts-web` : `${protocol}//${hostname}/${api.path}ts-web`;
            //console.log(`fidocrs endpoint is ${transmitEndpoint}`);

            const appId = api.tmtAppId;
            const apiTokenId = "";
            const apiToken = "";
            var sdk = xmsdk.XmSdk();

            var connectionSettings =
                com.ts.mobile.sdk.SDKConnectionSettings.create(
                    transmitEndpoint, appId, apiTokenId, apiToken);
            sdk.setConnectionSettings(connectionSettings);
            sdk.setLogLevel(com.ts.mobile.sdk.LogLevel.Debug);
            //sdk.setLocale("en-US");
            //var uiHandler = new xmui.XmUIHandler();
            sdk.setUiHandler(new CustomUIHandler());
            var myProvider = new CRSFidoAuthCustomTransport(api.headers.client_id);
            sdk.setTransportProvider(myProvider);
            sdk.setUiAssetsDownloadMode(
                com.ts.mobile.sdk.UIAssetsDownloadMode.Disable);
            let siteId = localStorage.getItem("siteId");
            let fidoUserId = localStorage.getItem(siteId + "_fidoUserId");
            let userId = localStorage.getItem(siteId +"_userId");
            var params: any;
            params={
                "fusionUser": userId
            }
            const transmitContainer = document.getElementById("transmitContainer");
            let transmitContent : any = {
                headerContent: transmitContainer.querySelector('#biometricHeader').innerHTML,
                continueBtnContent: transmitContainer.querySelector('#tmpContinueButton').innerHTML,
                cancelContent: transmitContainer.querySelector('#tmpCancelButton').innerHTML

            }
            var clientContext: any;
            clientContext={
                uiContainer: transmitContainer,
                transmitContent:transmitContent
            };
            sdk.initialize().then(function (initializeRes) {
                sdk.authenticate(fidoUserId,"crsFidoAuthenticate",params,clientContext).then(function (response){
                    resolve(new String(response.getToken()));
                }).catch(function (err) {
                    sdk.logout();
                    reject("emptyToken");
                });
            }).catch(function (err) {
                sdk.logout();
                reject(new String("emptyToken"));
            })
        } catch(err){
            biometricToken = "dummyToken";
            reject(new String(biometricToken));
        }
    });
    }

    setLocalStorage(json_data) {
        let siteId = localStorage.getItem("siteId");
        localStorage.setItem(siteId + "_userFIDORegistered", json_data.userFIDOregistered? json_data.userFIDOregistered: false);
        localStorage.setItem(siteId + "_devieEligible", json_data.deviceEligible);
    }

    redirectToNgaSignon() {
        let siteId = localStorage.getItem("siteId");
        let redirectUrl = localStorage.getItem(siteId + "_redirectUrlNgaSignon");
        if (redirectUrl) {
            window.location.href = redirectUrl;
        }
    }

    transmitSessionLogout(){
        try{
        const { protocol, hostname, port } = document.location;

            const config = this._appConfigService.getConfig("api");
            const api = config;
            //console.log(`fidocrs service api details is ${JSON.stringify(api)}`);
            const transmitEndpoint = (api.host) ? `${api.host}${api.path}ts-web` : `${protocol}//${hostname}/${api.path}ts-web`;
            //console.log(`fidocrs endpoint is ${transmitEndpoint}`);

            const appId = api.tmtAppId;
            const apiTokenId = "";
            const apiToken = "";
            var sdk = xmsdk.XmSdk();

            var connectionSettings =
                com.ts.mobile.sdk.SDKConnectionSettings.create(
                    transmitEndpoint, appId, apiTokenId, apiToken);
            sdk.setConnectionSettings(connectionSettings);
            sdk.setLogLevel(com.ts.mobile.sdk.LogLevel.Debug);
            //sdk.setLocale("en-US");
            //var uiHandler = new xmui.XmUIHandler();
            sdk.setUiHandler(new CustomUIHandler());
            var myProvider = new CRSFidoAuthCustomTransport(api.headers.client_id);
            sdk.setTransportProvider(myProvider);
            sdk.setUiAssetsDownloadMode(
                com.ts.mobile.sdk.UIAssetsDownloadMode.Disable);
            sdk.logout();
            }catch(err){

            }
    }

}

